// schema
import * as ISchema from "@schema";

// libraries
import * as React from "react";
import { connect } from "react-redux";
import { createFragmentContainer } from "react-relay";

// freemium-status-callout imports
import { IContainer, IProps, IState } from "./FreemiumStatusCallout.d";
import { freemiumStatusCalloutFragments } from "./FreemiumStatusCallout.gql";
import { styles } from "./FreemiumStatusCallout.styles";

// other components
import { A } from "@ui";

// state
import { IReduxState } from "@reducers/root.reducer";
import { setPricingDialogOpen } from "@actions/payments.actions";

// util
import { getStartOfNextCycle, getOrgAccountingPeriodFromOrg } from "@src/util/pricing.util";
import { track, TrackingEvents } from "@util/analytics.util";

// constatnts
import { salesContactFormUrl } from "@constants/site.constant";

// material-ui
import { Button } from "@material-ui/core";
import { Error } from "@material-ui/icons";
import withStyles from "@material-ui/core/styles/withStyles";

///////////////
// Component //
///////////////
class FreemiumStatusCalloutCmpt extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
  }

  // ~-~-~-~-~-~-~-
  // Helpers
  // ~-~-~-~-~-~-~-
  private getStyles = (status: ISchema.EnforcementStateEnum) => {
    const { classes } = this.props;

    const isOverLimit = status === ISchema.EnforcementStateEnum.ReachedLimit;
    return {
      container: isOverLimit ? classes.containerOverLimit : classes.containerApproachingLimit,
      header: classes.header,
      content: classes.content,
      button: isOverLimit ? classes.buttonOverLimit : classes.buttonApproachingLimit,
    };
  };

  // ~-~-~-~-~-~-~-
  // Handlers
  // ~-~-~-~-~-~-~-
  private onClickUpgrade = () => {
    this.props.setPricingDialogOpen(true);
    track(TrackingEvents.PAYWALLS.FREEMIUM_FEED_CALLOUT_CLICK_UPGRADE);
  };

  private onClickContactUs = () => {
    track(TrackingEvents.PAYWALLS.FREEMIUM_FEED_CALLOUT_CLICK_CONTACT_US);
  };

  // ~-~-~-~-~-~-~-
  // Render
  // ~-~-~-~-~-~-~-
  public render() {
    const { org, classes } = this.props;

    const orgAccountingPeriod = getOrgAccountingPeriodFromOrg(org);
    if (
      !orgAccountingPeriod ||
      orgAccountingPeriod.enforcementState === ISchema.EnforcementStateEnum.NoEnforcement ||
      orgAccountingPeriod.enforcementState === ISchema.EnforcementStateEnum.ApproachingLimit
    ) {
      return "";
    }

    const formattedNewCycleStartDate = getStartOfNextCycle(org.orgAccountingPeriod).format("MMM D");
    const generatedStyles = this.getStyles(orgAccountingPeriod.enforcementState);

    return (
      <div className={generatedStyles.container}>
        <Error />
        <div className={classes.right}>
          <div className={generatedStyles.header}>Free quota exceeded</div>
          <div className={generatedStyles.content}>
            Clockwise will stop scheduling and rescheduling events automatically until the next
            cycle (starting {formattedNewCycleStartDate}).
          </div>
          <div className={classes.actions}>
            <Button
              className={generatedStyles.button}
              onClick={this.onClickUpgrade}
              variant="outlined"
            >
              View Plans
            </Button>
            <div className={classes.contactContainer}>
              Or,{" "}
              <A
                onClick={this.onClickContactUs}
                href={salesContactFormUrl}
                target="_blank"
                style={styles.contactLink}
              >
                contact us.
              </A>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

/////////////////
// With Styles //
/////////////////
export const FreemiumStatusCalloutStyled = withStyles(styles)(FreemiumStatusCalloutCmpt);

///////////
// Redux //
///////////
function mapStateToProps(_state: IReduxState, _ownProps: IContainer) {
  return {};
}

const FreemiumStatusCalloutRedux = connect(mapStateToProps, {
  setPricingDialogOpen,
})(FreemiumStatusCalloutStyled);

///////////
// Relay //
///////////
export const FreemiumStatusCallout = createFragmentContainer<IContainer>(
  FreemiumStatusCalloutRedux,
  freemiumStatusCalloutFragments,
);
